import React, {useEffect} from "react";
import {FormattedMessage, useIntl} from "react-intl";

// import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import {AILimitIcon} from "../../../common/svgIcons/svgIcons";
import {IS_QKB_UI} from "../../../../config";
import {setLookAiImageOpened, setLookAiLimitBoxOpened} from "../../aiActions";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {useAppDispatch, useAppSelector} from "../../../../storeHooks";
import {toggleDesktopNavigation} from "../../../../actions/navigationFunctions";

// Shown instead of starting a new render once the user hit AI_RENDER_LIMIT (see aiConfig.ts) -
// opened from LookAIPopupGenerateButton and AIResultCustomPrompt. Same look as LookAIWaitingBox.

const LookAILimitBox = () => {

  const intl = useIntl();
  const dispatch = useAppDispatch();
  const lookAiLimitBoxOpened = useAppSelector(state => (state as any).aiState.lookAiLimitBoxOpened);
  // const fabricatorData = useAppSelector(state => (state as any).fabricatorState);
  const isMobile = useAppSelector(state => (state as any).serverState.isMobile);

  useEffect(() => {
    if (lookAiLimitBoxOpened) {
      dispatch(setLookAiImageOpened(false)); // the limit box replaces the opened AI image
      if (IS_QKB_UI) {
        dispatch(toggleDesktopNavigation(false)); // QKB ui
      }
    }
  }, [lookAiLimitBoxOpened, dispatch]);

  const continueDesigningClick = () => {
    dispatch(setLookAiLimitBoxOpened(false));
    dispatch(setLookOverlayOpened(""));
  };

  // const phone = fabricatorData.phone;

  return (
    <div style={{left: isMobile ? "23.5rem" : 0}}
         className={"fixed transition2 look-ai__overlay u-top-1 u-right-1 u-bottom-1"
      + (IS_QKB_UI ? " look-ai__overlay--qkb" : "")
      + (!lookAiLimitBoxOpened ? " opacity-0 visibility-hidden" : "")}>
      <div className={"look-intro__box look-icon--with-shadow"
        + (!lookAiLimitBoxOpened ? " look-intro__box--hidden" : "")
        + (isMobile ? " u-w-full" : "")}>
        <div className="grohe-lead__box-icon">
          {AILimitIcon}
        </div>
        <div className="flex flex--center flex--column h-full">
          <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                      className="look-icon look-icon--white2 look-icon--small absolute u-right-05 u-top-05 look-icon--gray8 rounded-full"
                      onClick={continueDesigningClick}>
            <CloseIcon/>
          </IconButton>
          <h2 className="look-intro__box-title bold u-mt-0">
            <FormattedMessage id="look.ai.limitBox.title"/>
          </h2>
          <p className="look-intro__box-text">
            <FormattedMessage id="look.ai.limitBox.text"/>
          </p>
          {/*{phone ? (*/}
          {/*  <p className="bold text-center mt-4">*/}
          {/*    <a href={"tel:" + phone} className="text-inherit no-underline">{phone}</a>*/}
          {/*  </p>*/}
          {/*) : null}*/}
          {/*<div className="look-intro__box-buttons">*/}
          {/*  <Button className={"look-button look-button--160 look-button--no-transform look-button--no-padding "*/}
          {/*    + (IS_QKB_UI ? " ui-button2 ui-button2--green ui-button2--white2 u-h-25"*/}
          {/*      : fabricatorData.isAmericanStandard ? "look-button--primary2" : "look-button--blue")}*/}
          {/*          onClick={continueDesigningClick}>*/}
          {/*    <FormattedMessage id="look.ai.waitingBox.button"/>*/}
          {/*  </Button>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};

export default LookAILimitBox;
